import httpAuth from "@/common/http/http-common";
import { OfficeDto } from "@/types/office.type";
import { PositionDto } from "@/types/position.type";
import { ShiftDeleteFormDto, ShiftFilterDto, ShiftGroupFormDataDto, ShiftGroupDto, ShiftGroupFormDto, PayRateStatisticsDto, ShiftDeleteFormDataDto, ShiftDataDto } from "@/types/shift.type";
import { ShiftGroupResponseStatusFormDto } from "@/types/shift-response.type";

class ShiftService {
  client = httpAuth("shift");

  async getFormAsync(id: number): Promise<ShiftGroupFormDto> {
    const { data } = await this.client.get(`${id}/form`);

    return data;
  }

  async getOfficesAsync(userId: number): Promise<OfficeDto[]> {
    const { data } = await this.client.get(`user/${userId}/office/all`);

    return data;
  }

  async saveAsync(form: ShiftGroupFormDto): Promise<void> {
    await this.client.put(".", form);
  }

  async getOfficeShiftsAsync(filter: ShiftFilterDto): Promise<ShiftGroupDto[]> {
    const { data } = await this.client.post("get-all/office", filter);

    return data;
  }

  async deleteAsync(form: ShiftDeleteFormDto): Promise<void> {
    await this.client.delete("group/delete", { data: form });
  }

  async updateResponseStatusAsync(form: ShiftGroupResponseStatusFormDto): Promise<void> {
    await this.client.put("group/response/status", form);
  }

  async getPositionsAsync(): Promise<PositionDto> {
    const { data } = await this.client.get("position/all");

    return data;
  }

  async getFormDataAsync(officeId: number): Promise<ShiftGroupFormDataDto> {
    const { data } = await this.client.get(`office/${officeId}/form/data`);

    return data;
  }

  async getPayRateStatisticsAsync(positionId: number): Promise<PayRateStatisticsDto> {
    const { data } = await this.client.get(`position/${positionId}/pay-stats`);

    return data;
  }

  async getDeleteFormDataAsync(): Promise<ShiftDeleteFormDataDto> {
    const { data } = await this.client.get("delete/form/data");

    return data;
  }

  async getDataAsync(): Promise<ShiftDataDto> {
    const { data } = await this.client.get("data");

    return data;
  }
}

export default new ShiftService();